import React, { useState } from "react";
import { View } from "@/styles/reactnative";
import MarketTrendHeader from "../MarketTrendHeader";
import RankingTableMarkets from "./RankingTableMarkets";
import RankingTableSectors from "./RankingTableSectors";
import RankingTopTabs from "./RankingTopTabs";
import { RankingTabsWrapper } from "./styles";

const WorldRanking = () => {
  const Market = "marketCap";
  const Sector = "sector";
  const [tab, setTab] = useState(Market);
  const tabs = [Market, Sector];
  return (
    <View style={{ alignItems: "flex-start" }}>
      <MarketTrendHeader title={"rankings"} />
      <RankingTopTabs tab={tab} setTab={setTab} tabs={tabs} />
      <RankingTabsWrapper>
        {tab === Market ? <RankingTableMarkets /> : null}
        {tab === Sector ? <RankingTableSectors /> : null}
      </RankingTabsWrapper>
    </View>
  );
};

export default React.memo(WorldRanking);
